import React from 'react';

const MathIcon = () => {
  return (
    <svg t="1680024822405" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
         p-id="13618" width="16" height="16">
      <path
        d="M832 832H386.24L832 386.24z m-291.2-64H768v-227.2zM200 672H64v-136L507.2 93.12a96 96 0 0 1 135.68 135.68zM128 608h45.44L597.76 183.68a32 32 0 0 0-45.44-45.12L128 562.56z"
        p-id="13619"></path>
      <path
        d="M439.136 206.208l45.28-45.248 90.496 90.496-45.28 45.248zM1024 1024H0v-77.12L946.88 0H1024zM77.44 960H960V77.12z"
        p-id="13620"></path>
    </svg>
  );
};

export default MathIcon;